import script from "./support-status-toolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./support-status-toolbar.vue?vue&type=script&lang=ts&setup=true"

import "./support-status-toolbar.vue?vue&type=style&index=0&id=43a5b022&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a5b022"]])

export default __exports__